import React from 'react';

import { DualTime as NewDualTime } from '@/ui/DualTime/DualTime';

import type { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const DualTime = (props: Props) => <NewDualTime {...props} />;

export default React.memo(DualTime);
